import { RootState } from "../rootReducer"
import { massMailingAdapter } from "./slice"

export const { selectAll: selectMassMailings, selectById: selectMassMailingById } = massMailingAdapter.getSelectors(
    (state: RootState) => state.massMailing
)
